/**
 * When VITE_BACKEND_URL is unset, requests are same-origin relative paths (e.g. `/api/...`),
 * which works whenever the SPA is served from the same CloudFront distribution as
 * `api/*` and `backend/auth/*` e.g. an ephemeral environment on a bare *.cloudfront.net
 * domain.
 */
export default function getBackendUrl(): string {
  return import.meta.env.VITE_BACKEND_URL ?? '';
}
